
const state = {
  lang: localStorage.lang || (localStorage.lang = 'FR')
}

const getters = {
  getLang: state => state.lang
}

const actions = {
}

const mutations = {
  'UPDATE_LANG': (state, language) => { state.lang = localStorage.lang = language }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
